import { useCallback, useState } from 'react'
import { RowsPerPageType } from '@node-space/ui-components'

/**
 * Use this hook for client-side pagination where all data is loaded at once.
 * For server-side pagination with API calls, use usePaginationWithApi instead.
 */
export const useSimplePagination = (initialRowsPerPage: RowsPerPageType = 10) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState<RowsPerPageType>(initialRowsPerPage)

  const handleChangePage = useCallback((newPage: number) => {
    setPage(newPage)
  }, [])

  const handleChangeRowsPerPage = useCallback((newRowsPerPage: RowsPerPageType) => {
    setRowsPerPage(newRowsPerPage)
    setPage(0)
  }, [])

  return {
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
  }
}
